import PropTypes from 'prop-types'
import React from 'react'
import Markdown from 'components/markdown'
import 'styles/components/markdown-for-offers-page.scss'

const MarkdownForOffersPage = ({ content }) => <Markdown className="markdown-for-offers-page" content={content} />

MarkdownForOffersPage.propTypes = {
  content: PropTypes.string
}

MarkdownForOffersPage.defaultProps = {
  content: null
}

export default MarkdownForOffersPage
